import React, { useEffect, useState, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './DeleteConfirmation.scss';
import { Button } from '@/components/Elements';
const DeleteConfirmation: VFC<{
  onConfirm: (data?: any) => void;
  onClose: () => void;
  open: boolean;
  message?: string;
  subText?: string;
  confirmationBtnTxt?: string;
  data?: any;
  archivedUsersList?: any;
}> = ({ open, message, subText, confirmationBtnTxt, onConfirm, onClose, data, archivedUsersList }) => {
  const [archivedUserIds, setArchivedUserIds] = useState<any>([]);

  const addToArchive = (userId?: any) => {
    setArchivedUserIds((prev: any) =>
      prev.includes(userId)
        ? prev.filter((id: any) => id !== userId)
        : [...prev, userId]
    );
  }
  return (
    <>
      <Modal
        show={open}
        onHide={() => onClose()}
        className="rewise-modal-dialog  reject-apptmt-dialog"
        size="sm"
      >
        <Modal.Header closeButton>
          <div className="model-header-tab-1">
            <div className="modal-title">{subText}</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className='delete-msg'>
            {message ? message : 'Are you sure you want to delete?'}
          </div>
          {data && <div className='delete-details'>
            <div className='institute'>
              {data?.institute?.name}

            </div>
            <div className='personal-detail'>
              {data?.name} | {data?.email} | +{data?.phone}
            </div>
          </div>}
          {archivedUsersList && archivedUsersList?.length > 0 && <div className='archive-text'>
            Archive all funnels of these users :
          </div>}
          {archivedUsersList && archivedUsersList?.length > 0 && archivedUsersList.map((item: any) => {
            return (
              <div className='archive-funnel-user-list' >
                <label key={item?.id}
                  htmlFor={`option-check-${item?.id}`} className="check-container mt-btn">
                  <input
                    checked={archivedUserIds.includes(item?.id)}
                    id={`option-check-${item?.id}`}
                    type="checkbox"
                    onChange={() => addToArchive(item?.id)}
                  />
                  <span className="checkmark"></span>
                </label>
                <div className='archive-username'>{item?.name}</div>
              </div>)
          })}
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-container display-flex">
            <button
              className={`steam-button cancel-button `}
              onClick={async () => {
                onClose();
              }}
            >
              <span className='secondary'>{'Cancel'}</span>
            </button>
            <button
              className={`steam-button button-dark display-flex `}
              onClick={async () => {
                setArchivedUserIds([]);
                onConfirm(archivedUserIds);
              }}
            >
              <span> {confirmationBtnTxt ? confirmationBtnTxt : 'Confirm'}</span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default DeleteConfirmation;
